<div>
  Show
  <select class="form-control-sm d-inline" [formControl]=itemLength>
    <option [ngValue]="10">10</option>
    <option [ngValue]="50">50</option>
    <option [ngValue]="100">100</option>
    <option [ngValue]="500">500</option>
  </select>
  entires
</div>
